module.exports = __webpack_public_path__ + "static/media/SalesRevenue.1f2468e9.svg";